import React, { Component } from 'react';
import { Table, DatePicker } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Highcharts from 'react-highcharts';
import chartsConfig from '../../common/chartsConfig';
import ExportUtil from '../../../common/ExportUtil';
import SideNav from '../SideNav';
import moment from 'moment';

const monthFormat = 'YYYY-MM'
const { MonthPicker } = DatePicker;

class siteStart extends Component {
    state = {
        data: [],
        params: {},
        name: this.props.match.params.name,
        startDate: moment().add(-11, 'M'),
        endDate: moment(),
        loading: false,
    }

    componentDidMount() {
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG','downloadPDF', 'downloadPNG', 'downloadSVG','label',
        ];
        chartsConfig.exporting.menuItemDefinitions.label = {
            onclick: () => {
                const { params, date,startDate,endDate } = this.state;
                let{ match: { params: { name: type } } } = this.props;
                let url = API_URL.summary.exportInvestigationSiteStatistic;
                ExportUtil.export({
                    ...params,
                     ...date,
                     startDate:startDate.format(monthFormat),
                     endDate:endDate.format(monthFormat),
                     type
                    }, null, url);
            },
            text: '导出Excel'
        }
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.name !== this.props.match.params.name) {
            this.setState({
                startDate: moment().add(-11, 'M'),
                endDate: moment(),
            }, () => {
                this.loadData();
            })
        }
    }
    
    loadData = () => {
        const { match: { params: { name: type } } } = this.props;
        const { startDate, endDate } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: `${API_URL.plan.queryInvestigationSiteStatistic}`,
            data: {
                startDate: startDate.format(monthFormat),
                endDate: endDate.format(monthFormat),
            },
            dateType: 'json',
            doneResult: res => {
                const data = res.data;

                let key = 0;
                let title = '';
                let monthList = [];
                if (Array.isArray(data)) {
                    data.forEach(item => {
                        monthList.push(`${item.title.split('.')[1]}月`);
                    });

                    const child = data[0] || {};
                    if (child.investigationStartList && Array.isArray(child.investigationStartList)) {
                        child.investigationStartList.forEach((item, index) => {
                            if (item.type == type) {
                                key = index;
                                title = item.typeName;
                            }
                        });
                    }
                }

                this.setState({
                    key,
                    data,
                    title,
                    monthList,
                    loading: false,
                });
            }
        }
        $.sendRequest(options)      
    }

    getColumns = () => {
        const columns = []
        columns.push({
            title: '',
            dataIndex: 'index',
            key: 'index',
        });
        const { monthList } = this.state;
        if (Array.isArray(monthList)) {
            monthList.forEach(item => {
                columns.push({
                    title: item,
                    dataIndex: item,
                    key: item,
                });
            });
        }
        return columns
    }

    getDataSource = () => {
        const { key, data } = this.state;
        const dataSource = [];
        if (Array.isArray(data)) {
            const monthPlanParams = { index: '月度计划' };
            const totalPlanParams = { index: '累计计划' };
            const monthActualParams = { index: '月度实际' };
            const totalActualParams = { index: '累计实际' };

            data.forEach(item => {
                const month = `${item.title.split('.')[1]}月`;
                if (Array.isArray(item.investigationStartList)) {
                    monthPlanParams[month] = item.investigationStartList[key].monthPlan;
                    totalPlanParams[month] = item.investigationStartList[key].cumulativePlan;
                    monthActualParams[month] = item.investigationStartList[key].monthActual;
                    totalActualParams[month] = item.investigationStartList[key].cumulativeActual;
                }
            });

            dataSource.push(monthPlanParams);
            dataSource.push(totalPlanParams);
            dataSource.push(monthActualParams);
            dataSource.push(totalActualParams);
        }
        return dataSource
    }

    handleDateStartChange = (date) => {
        this.setState({ 
            startDate: date,
            endDate: moment(date).add(11, 'M'),
        }, () => {
            const { endDate } = this.state;
            date && endDate && this.loadData();
        });
    }

    handleDateEndChange = (date) => {
        this.setState({ 
            endDate: date,
            startDate: moment(date).add(-11, 'M'),
        }, () => {
            const { startDate } = this.state;
            startDate && date && this.loadData();
        });
    }

    getConfig = () => {
        const { key, data, monthList } = this.state;
        const monthPlanList = [];
        const totalPlanList = [];
        const monthActualList = [];
        const totalActualList = [];
        if (Array.isArray(data)) {
            data.forEach(item => {
                if (Array.isArray(item.investigationStartList)) {
                    monthPlanList.push(item.investigationStartList[key].monthPlan);
                    totalPlanList.push(item.investigationStartList[key].cumulativePlan);
                    monthActualList.push(item.investigationStartList[key].monthActual);
                    totalActualList.push(item.investigationStartList[key].cumulativeActual);
                }
            });
        }

        const config = {
            chart: {
                zoomType: 'xy',
                // height: 600,
            },
            title: {
                text: ''
            },
            xAxis: [{
                categories: monthList,
                crosshair: true
            }],
            yAxis: [{
                title: {
                    text: '',
                },
                opposite: true
            }, {
                title: {
                    text: '',
                },
            }],
            tooltip: {
                shared: true
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                x: 0,
                y: 20,
                verticalAlign: 'top',
            },
            series: [{
                name: '月度计划',
                type: 'column',
                yAxis: 1,
                color: '#D4514D',
                data: monthPlanList,
            },{
                name: '月度实际',
                type: 'column',
                yAxis: 1,
                color: '#58819D',
                data: monthActualList,
            }, {
                name: '累计计划',
                type: 'spline',
                color: '#FFCC00',
                data: totalPlanList,
            }, {
                name: '累计实际',
                type: 'spline',
                color: '#03CC35',
                data: totalActualList,
            }],
            credits: {
                enabled: false
            }
        };
        return config;
    }

    render() {
        const {
            loading,
            title,
            startDate,
            endDate,
        } = this.state;

        const config = this.getConfig();

        return (
            <div className="content">
                <SideNav />
                <div className="main">                    
                    <div className="T-tit">
                        <div className="txt">
                            <h3 style={{ marginBottom: 10 }}>{title} </h3>
                            <div style={{ textAlign: 'left' }}>
                                <MonthPicker
                                    value={startDate}
                                    style={{verticalAlign: 'middle'}}
                                    onChange={this.handleDateStartChange}
                                />
                                <span className="ant-divider" />
                                <MonthPicker
                                    value={endDate}
                                    style={{verticalAlign: 'middle'}}
                                    onChange={this.handleDateEndChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="charts" style={{ marginTop: 20, marginBottom: 20 }}>
                        <Highcharts config={{...config, ...chartsConfig}} />
                    </div>
                    <div className="content">
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.index}
                            loading={loading}
                            pagination={false}
                            bordered
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default siteStart;


// WEBPACK FOOTER //
// ./src/components/summary/siteStart/index.js